// 珍品app方法
/*跳转1销售分类、2品牌、3搜索、4专题ID  0的时候id是个h5链接*/
function getCookie(name) {
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    var arr = document.cookie.match(reg)
    return arr ? unescape(arr[2]) : ''
}

function getAuthCookie() {
    return {
        zpmemberid: getCookie('zpmemberid'),
        zptoken: getCookie('zptoken'),
        deviceid: getCookie('deviceid')
    }
}

function ltIOS8() {
    var str = navigator.userAgent.toLowerCase()
    var ver = str.match(/cpu iphone os (.*?) like mac os/)
    if (!ver) return false
    var curIOS = ver[1].split('_')[0] - 0
    return curIOS <= 8
}

// 相对于网页有过修改，只能跳转app(因为页面在app中)
var toSearch = function(type, id, title, name, gender, specialId, filterBrand) {
    var versionFlag = getCookie('version'),
        config = {
            type: type,
            id: id,
            title: title,
            gender: gender,
            specialId: specialId,
            filterBrand: filterBrand,
            name: name
        }

    config = JSON.stringify(config)

    var ua = navigator.userAgent,
        ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid

    if (isMobile) {
        //或者单独判断iphone或android
        if (isIphone) {
            if (type == 1) {
                try {
                    window.webkit.messageHandlers.iosSkipProductList.postMessage([
                        type,
                        'home_cate_sale|' + id,
                        title,
                        name,
                        gender
                    ])
                } catch {
                    window.iosSkipProductList(type, 'home_cate_sale|' + id, title, name, gender)
                }
            } else if (type == 4) {
                var version = versionFlag
                var breakpoint = '4.0.5'

                var versionArray = version.split('.')
                var breakpointArray = breakpoint.split('.')
                var str = false

                var maxLength =
                    versionArray.length >= breakpointArray.length ? versionArray.length : breakpointArray.length
                for (var i = 0; i < maxLength; i++) {
                    var versionNum = versionArray[i] || 0
                    var breakpointNum = breakpointArray[i] || 0
                    if (versionNum > breakpointNum) {
                        str = true
                        break
                    } else if (versionNum < breakpointNum) {
                        str = false
                        break
                    }
                }
                if (version == breakpoint) {
                    str = true
                }

                if (str) {
                    try {
                        window.webkit.messageHandlers.iosSkipProductList.postMessage(config)
                    } catch {
                        window.iosSkipProductList(config)
                    }
                } else {
                    window.location.href =
                        'https://m.zhen.com/index.php?c=APP_special&a=special_info&specialUrl=' +
                        specialId +
                        '&specialTitle=' +
                        title
                }
            } else if (type == 0) {
                window.location.href = id
            } else {
                try {
                    window.webkit.messageHandlers.iosSkipProductList.postMessage([type, id, title, name, gender])
                } catch {
                    window.iosSkipProductList(type, id, title, name, gender)
                }
            }
        } else if (isAndroid) {
            if (type == 1) {
                window.adObject.androidToProductList(type, 'home_cate_sale|' + id, title, gender)
            } else if (type == 4) {
                var versionx = versionFlag
                var breakpointx = '4.0.5'

                var versionArrayx = versionx.split('.')
                var breakpointArrayx = breakpointx.split('.')
                var strx = false

                var maxLengthx =
                    versionArrayx.length >= breakpointArrayx.length ? versionArrayx.length : breakpointArrayx.length
                for (var j = 0; j < maxLengthx; j++) {
                    var versionNumx = versionArrayx[j] || 0
                    var breakpointNumx = breakpointArrayx[j] || 0
                    if (versionNumx > breakpointNumx) {
                        strx = true
                        break
                    } else if (versionNumx < breakpointNumx) {
                        strx = false
                        break
                    }
                }
                if (versionx == breakpointx) {
                    strx = true
                }

                if (strx) {
                    window.adObject.androidToProductList(config)
                } else {
                    window.location.href =
                        'https://m.zhen.com/index.php?c=APP_special&a=special_info&specialUrl=' +
                        specialId +
                        '&specialTitle=' +
                        title
                }
            } else if (type == 0) {
                window.location.href = id
            } else {
                window.adObject.androidToProductList(type, id, title, gender)
            }
        }
    } else {
        if (type == 1) {
            window.location.href =
                'https://m.zhen.com/index.php?c=search&cid=home_cate_sale|' + id + '&specialTitle=' + title
        } else if (type == 4) {
            window.location.href =
                'https://m.zhen.com/index.php?c=APP_special&a=special_info&specialUrl=' +
                specialId +
                '&specialTitle=' +
                title
        } else if (type == 0) {
            window.location.href = id
        } else {
            window.location.href = 'https://m.zhen.com/index.php?c=search&brandid=' + id + '&specialTitle=' + title
        }
    }
}

const ua = navigator.userAgent
let usLower = navigator.userAgent.toLowerCase()

// 是苹果
const isIphone = () => {
    let isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
    return isIos
}

const ipad = () => {
    return ua.match(/(iPad).*OS\s([\d_]+)/)
}

const isAndroid = () => {
    if (usLower.indexOf('android') > -1 || usLower.indexOf('adr') > -1) {
        return true
    }
    return false
}

const isInApp = () => {
    if (usLower.indexOf('zhenpinapp') > -1) {
        return true
    }
    return false
}

// 是否在小程序中
const isInWx = () => {
    // 1. 先判断是否有 wx 对象（小程序原生或引入了JS-SDK）
    if (typeof wx === 'undefined') return false

    // 2. 小程序原生环境：有 wx.navigateTo 等小程序API
    if (typeof wx.navigateTo === 'function') return true

    // 3. webview 内嵌 H5 环境：通过 miniProgram 对象判断
    if (wx.miniProgram && typeof wx.miniProgram.getEnv === 'function') {
        // 同步方式：直接判断 UA 作为兜底
        if (typeof navigator !== 'undefined') {
            const ua = navigator.userAgent.toLowerCase()
            if (ua.includes('miniprogram') || ua.includes('wechatdevtools')) {
                return true
            }
        }
        // 异步方式（更准确，需要回调）
        // wx.miniProgram.getEnv(res => console.log(res.miniprogram))
    }

    // 4. 兜底：通过 UA 判断（适用于未引入JS-SDK的webview）
    if (typeof navigator !== 'undefined') {
        const ua = navigator.userAgent.toLowerCase()
        return ua.includes('miniprogram') || ua.includes('wechatdevtools')
    }

    return false
}

// H5 调起app的客服 入参商品id
const goCustomerServiceOld = id => {
    let isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
    let productId = id ? id.toString() : ''
    if (isIos) {
        try {
            window.webkit.messageHandlers.toCustomerService.postMessage([productId])
        } catch {
            window.toCustomerService(productId)
        }
    } else {
        window.adObject.toCustomerService(productId)
    }
}
const goCustomerService = productObj => {
    const { productName, productImage, productUrl } = productObj
    let isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
    if (isIos) {
        try {
            window.webkit.messageHandlers.toCustomerService.postMessage([productName, productImage, productUrl])
        } catch {
            window.toCustomerService(productName, productImage, productUrl)
        }
    } else {
        window.adObject.toCustomerService(productName, productImage, productUrl)
    }
}

// 存储
export const saveWords = words => {
    localStorage.setItem('words', JSON.stringify(words))
}

// 获取
export const getWords = () => {
    return JSON.parse(localStorage.getItem('words'))
}

export const getSearchData = (selectArrList, value, id) => {
    let getSelect = selectArrList.map(item => item[value])
    let getStr = getSelect.reverse().toString()
    let getIds = selectArrList
        .map(item => item[id])
        .reverse()
        .toString()
    return {
        getStr,
        getIds
    }
}
export const getFilters = (arr, value, id) => {
    let getValue = []
    let getIds = []
    const search = (arr, value, id) => {
        arr.forEach(item => {
            getValue.push(item[value])
            getIds.push(item[id])
            if (Array.isArray(item.children) && item.children.length > 0) {
                search(item.children, value, id)
            }
        })
    }
    search(arr, value, id)
    return {
        getStr: getValue.reverse().toString(),
        getIds: getIds.reverse().toString()
    }
}

export default {
    toSearch,
    getCookie,
    getAuthCookie,
    ltIOS8,
    isIphone,
    isAndroid,
    ipad,
    goCustomerService,
    isInApp,
    isInWx,
    saveWords,
    getWords,
    getSearchData
}
